import React from "react";
import CleverPeLogo from "@/assets/logo/CleverPe_Black_H.svg";
import Footer from "@/components/Footer";

const LendingPartners = () => {
  const partners = [
    {
      name: "Bhanix Finance & Investment Ltd.",
      logo: new URL('@/assets/lendingpartners/bhanix.png', import.meta.url).href,
      link: "https://www.bhanixfinance.com/ourpartners.html", // 🔗 Added link
      details: {
        title: "Grievance Redressal Officer",
        officer: "Ms. Pushpinder Kaur",
        tel: "9983107444",
        email: "grievance@bhanix.in"
      }
    },
    {
      name: "Respo Financial Capital Pvt Ltd.",
      logo: new URL('@/assets/lendingpartners/respowhite.png', import.meta.url).href,
      link: "https://respo.co.in/our-partners/", // 🔗 Added link
      details: {
        title: "Grievance Redressal Officer",
        officer: "Mr. Swapnil Kinalekar",
        tel: "022-28256467",
        email: "nodal@respo.co.in"
      }
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Header */}
      <header className="py-4 sm:py-6 px-4 sm:px-8 bg-white shadow">
        <div className="max-w-screen-xl mx-auto flex justify-between items-center">
          <img src={CleverPeLogo} alt="CleverPe Logo" className="h-12 sm:h-16" />
          <a
            href="/"
            className="px-4 sm:px-6 py-2 sm:py-3 bg-gradient-purple text-white text-sm sm:text-base font-semibold rounded-lg hover:from-[#A604F2] hover:to-[#763AF5]"
          >
            Go Back
          </a>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow px-4 sm:px-8 py-12">
        <div className="max-w-screen-xl mx-auto">
          <h1 className="text-4xl sm:text-6xl font-bold text-center text-gray-900 mb-12">
            Lending Partners
          </h1>

          {/* Responsive Grid for Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {partners.map((partner) => (
              <div key={partner.name} className="space-y-2">
                {/* Partner Name */}
                <div className="text-lg text-gray-700 pl-2">
                  {partner.name}
                </div>

                {/* Partner Card */}
                <div className="bg-black rounded-2xl overflow-hidden w-full h-[220px] flex">
                  {/* Logo Section */}
                  <div className="flex items-center justify-center w-2/5 p-6 bg-black/10">
                    {partner.link ? (
                      <a
                        href={partner.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={partner.logo}
                          alt={`${partner.name} logo`}
                          className="object-contain max-h-32"
                        />
                      </a>
                    ) : (
                      <img
                        src={partner.logo}
                        alt={`${partner.name} logo`}
                        className="object-contain max-h-32"
                      />
                    )}
                  </div>

                  {/* Divider */}
                  <div className="w-px self-stretch bg-white/20"></div>

                  {/* Info Section */}
                  <div className="flex flex-col justify-center w-2/5 p-6 text-white space-y-2">
                    <p className="text-base font-medium opacity-80 whitespace-nowrap">
                      {partner.details.title}:
                    </p>
                    <p className="text-lg font-bold opacity-90 whitespace-nowrap">
                      {partner.details.officer}
                    </p>
                    <p className="text-base opacity-80 whitespace-nowrap">
                      Tel: {partner.details.tel}
                    </p>
                    <p className="text-base opacity-80 whitespace-nowrap">
                      Email: {partner.details.email}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer bgColor="bg-[#2F2E2E]" />
    </div>
  );
};

export default LendingPartners;
